import React from "react";
import PropTypes from "prop-types";
import { CustomButton } from "@hapinest/theme";
import { Box, DialogActions, DialogContent, DialogTitle, makeStyles, Typography } from "@material-ui/core";
import { useI18N } from "../../../common/common";
import NoIndexDialog from "../../dialog/noIndex/NoIndexDialog";
import ResortSelection from "./ResortSelection";
import { useBreakpoints } from "../../../hooks";

const useStyles = makeStyles((theme) => ({
    dialog: {
        minHeight: theme.spacing(87.5),
        overflowY: "hidden",
        [theme.breakpoints.up("sm")]: {
            borderRadius: theme.spacing(5),
        },

        "& .MuiDialogContent-root": {
            borderTop: "1px solid " + theme.palette.secondary.main,
            borderBottom: "none",
        },

        "& .MuiDialogActions-spacing": {
            zIndex: 10,
            padding: theme.spacing(2),
            boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 3px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 8px 0px rgba(0, 0, 0, 0.20);"
        }
    },
    dialogFull: {
        height: "100vh",
        maxHeight: "100% !important",
        minHeight: "100% !important",
        overflowY: "hidden",
        borderRadius: 0,
    },
    dialogContent: {
        height: "650px",
        padding: "0px !important",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        margin: theme.spacing(0, 2),

        [theme.breakpoints.up("sm")]: {
            margin: theme.spacing(0, 1),
        },
    },
}));


const ResortSelectionDialog = ({open, onClose, resortId, onResortSelected}) => {
    const classes = useStyles();
    const {i18n} = useI18N();
    const {isExtraSmallScreen, isSmallScreenVertical} = useBreakpoints();

    const handleResortSelected = (resortId) => {
        onResortSelected(resortId);
    };

    return (
        <NoIndexDialog
            open={open}
            fullScreen={isExtraSmallScreen()}
            fullWidth={!isExtraSmallScreen()}
            maxWidth="lg"
            onClose={onClose}
            PaperProps={{
                className: isSmallScreenVertical() ? classes.dialogFull : classes.dialog,
                id: "resort_select"
            }}
        >
            <DialogTitle>
                <Box
                    mt={1}
                >
                    <Typography
                        variant="h4"
                        align="center"
                    >
                        {i18n("common.label.select_destination")}
                    </Typography>
                </Box>
            </DialogTitle>

            <DialogContent
                className={classes.dialogContent}
                dividers
            >
                <ResortSelection
                    resortId={resortId}
                    onResortSelected={handleResortSelected}
                />
            </DialogContent>

            {isExtraSmallScreen() && (
                <DialogActions>
                    <CustomButton
                        variant="outlined"
                        color="black"
                        size="large"
                        fullWidth
                        onClick={onClose}
                    >
                        {i18n("common.label.close")}
                    </CustomButton>
                </DialogActions>
            )}
        </NoIndexDialog>
    );
};

ResortSelectionDialog.defaultProps = {};

ResortSelectionDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    resortId: PropTypes.number,
    onResortSelected: PropTypes.func,
};

export default ResortSelectionDialog;
